<div class="popup-overlay" (click)="close()">
    <div class="popup-content" (click)="$event.stopPropagation()">
      <div class="video-container">
        <iframe 
          [src]="safeUrl" 
          frameborder="0" 
          allowfullscreen>
        </iframe>
      </div>
      <button class="close-btn" (click)="close()">×</button>
    </div>
  </div>